import React, { useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { resetPassword } from '../../libs/api';
import { AES } from 'crypto-js';
import Button from '../common/Button';
import styles from '@/assets/styles/ResetPassword.module.less';
import ThreeBackground from './ThreeBackground';

const ResetPassword: React.FC = () => {
  const { token: pathToken } = useParams<{ token: string }>();
  const [searchParams] = useSearchParams();
  const queryToken = searchParams.get('token');

  // 优先使用查询参数中的 token，如果没有则使用路径参数
  const token = queryToken || pathToken;

  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('两次输入的密码不一致');
      return;
    }
    setError('');
    setMessage('');

    const secretKey = process.env.REACT_APP_AES_SECRET_KEY;
    if (!secretKey) {
      setError('客户端配置错误。');
      return;
    }

    const encryptedPassword = AES.encrypt(password, secretKey).toString();

    if (!token) {
      setError('无效的重置令牌。');
      return;
    }

    try {
      await resetPassword({ token, password: encryptedPassword });
      setMessage('密码重置成功！');
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err) {
      setError('密码重置失败，链接可能已失效。');
      console.error('Reset password error:', err);
    }
  };

  return (
    <div className={styles['auth-page']}>
      <ThreeBackground />
      <div className={styles['auth-container']}>
        <form onSubmit={handleSubmit} className={styles['auth-form']}>
          <h2>重置密码</h2>
          <input
            type="password"
            placeholder="新密码"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="确认新密码"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            required
          />
          <Button type="submit" onClick={handleSubmit} className="primaryButton">
            重置密码
          </Button>
          {message && <p style={{ color: 'green' }}>{message}</p>}
          {error && <p style={{ color: 'red' }}>{error}</p>}
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
